<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M21 7L9 19 3.5 13.5 5.62 11.38 9 14.76 18.88 4.88 21 7z"/>
    </svg>
</template>

<script>
export default {
    name: 'CheckIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
